import React from 'react'
import type { ColumnsType } from 'antd/es/table'
import { type HoldingsColumnConfig, prepareDataForExport } from './holdings_table_columns.ts'

// Columns for the account form "Commitments" tab (view__account_commitments_tablegrid).
// Fund-centric: one row per fund_commitment the account has made, plus a
// per-currency Total row (funds__name is set to 'Total' by the tab).
const commitmentsColumnsConfig: HoldingsColumnConfig[] = [
  { columnTitle: 'Fund', valueKey: 'funds__name', width: 200 },
  { columnTitle: 'Investor Entity', valueKey: 'investors__name', width: 200 },
  { columnTitle: 'Status', valueKey: 'fund_commitment_statuses__label', width: 130 },
  { columnTitle: 'Commitment', valueKey: 'fund_commitments__amount_fmt', width: 140, fieldType: 'currency' },
  { columnTitle: 'Date Committed', valueKey: 'fund_commitments__date_committed_fmt', width: 130, fieldType: 'date' },
  { columnTitle: 'Date Closed', valueKey: 'fund_commitments__date_closed_fmt', width: 130, fieldType: 'date' },
  { columnTitle: 'Mgmt Fee', valueKey: 'fund_commitments__management_fee_rate_fmt', width: 100, fieldType: 'number' },
  { columnTitle: 'Base Carry', valueKey: 'fund_commitments__base_carry_rate_fmt', width: 100, fieldType: 'number' },
  { columnTitle: 'Base Hurdle', valueKey: 'fund_commitments__base_hurdle_multiple_fmt', width: 110, fieldType: 'number' },
  { columnTitle: 'Stepped Carry', valueKey: 'fund_commitments__stepped_carry_rate_fmt', width: 110, fieldType: 'number' },
  { columnTitle: 'Stepped Hurdle', valueKey: 'fund_commitments__stepped_hurdle_multiple_fmt', width: 120, fieldType: 'number' }
]

const NUMERIC_FIELD_TYPES: HoldingsColumnConfig['fieldType'][] = ['number', 'currency', 'valuation']

function configToColumns(config: HoldingsColumnConfig[]): ColumnsType<Record<string, unknown>> {
  return config.map((col) => {
    const displayValue = (val: unknown) => (val != null && val !== '' ? String(val) : '-')
    const isNumeric = col.fieldType && NUMERIC_FIELD_TYPES.includes(col.fieldType)
    return {
      title: col.columnTitle,
      dataIndex: col.valueKey,
      key: col.valueKey,
      width: col.width,
      render: (val: unknown) =>
        isNumeric ? React.createElement('div', { className: 'text-right' }, displayValue(val)) : displayValue(val)
    }
  })
}

export const commitmentsTableColumns = configToColumns(commitmentsColumnsConfig)
export { commitmentsColumnsConfig, prepareDataForExport }
